export const getRGBAColor = (colorVar: string, alpha: number) => {
  const color = getComputedStyle(document.documentElement)
    .getPropertyValue(colorVar)
    .trim();
  if (color.startsWith("#")) {
    // Convert Hex to RGB
    const hex = color.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return color; // If it's already a valid color, return it as is
};
